import { default as Layout } from './Layout';

export { default as LayoutBase } from './Base';
export { default as LayoutSimple } from './Simple';

export default Layout;
